export default __webpack_public_path__ + "static/robotomono-regular-f83dc6b92d6602fde8db40c527e068af.woff2";